import React from "react";
import { CircuitBoard } from "lucide-react";

const SwitchgearDesign = () => {
  return (
    <section className="bg-gradient-to-br from-white via-emerald-50 to-emerald-100 border-t-4 border-emerald-600 py-20 px-6 md:px-16">
      <div className="max-w-6xl mx-auto text-center">
        {/* Section Icon */}
        <div className="flex justify-center mb-6">
          <div className="bg-emerald-100 p-4 rounded-full shadow-md">
            <CircuitBoard className="h-8 w-8 text-emerald-700" />
          </div>
        </div>

        {/* Heading */}
        <h2 className="text-4xl font-bold text-emerald-700 mb-6">SWITCHGEAR</h2>

        {/* Description */}
        <p className="text-gray-800 text-lg font-semibold mb-4">
          We specialize in the complete design of low, medium, and high voltage switchgear systems such as 33kV, 11kV, 6.6kV, and 3.3kV.
        </p>
        <p className="text-gray-700 mb-4">
          The term <strong>Switchgear</strong> refers to a collection of switching and protection devices required for controlling electrical circuits.
          It includes components such as fuses, circuit breakers, isolators, disconnect switches, and relays used to manage the flow of electricity.
        </p>

        {/* Bulleted List */}
        <div className="text-left max-w-3xl mx-auto mt-8 text-gray-800 text-base leading-relaxed">
          <p className="font-semibold mb-2">Our key design capabilities include:</p>
          <ul className="list-disc list-inside space-y-2">
            <li>Designing of Bus Bar schematic</li>
            <li>Preparation of logic (AND & OR)</li>
            <li>Preparation of 2D/3D modeling</li>
            <li>Design of control circuits (tripping & closing)</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SwitchgearDesign;

